import { useNode } from "@craftjs/core";
import React from "react";
import { IconSettings } from "./settings";
import SVGIcons from "../../input/icons.json";
import SVG from "react-inlinesvg";
import GrigoraCSSRenderer from "../css-render";
import icon from "./icon";
import { CMSIconSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";

export const Icon = (props) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const { icon = "router", customIcon, hasCustomIcon } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-icon": true,
      [`icon-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Icon(id, props)}`}</style>
      {hasCustomIcon && customIcon !== "" ? (
        <SVG title={icon} src={customIcon} />
      ) : (
        <>
          {icon && SVGIcons[icon] && <SVG title={icon} src={SVGIcons[icon]} />}
        </>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
Icon.displayName = "Icon";

Icon.craft = {
  name: "Icon",
  props: {},
  related: {
    CMSsettings: CMSIconSettings,
    settings: IconSettings,
    supports: [
      "grigora/directory-conditional",
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    CMSIcon: CMSIcon,
    icon: icon,
    keywords: ["SVG", "Icon"],
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Icon",
    slug: "grigora/icon",
  },
};
